import { NgModule } from "@angular/core";

import { RaskCommonModule } from "~app/common/rask-common.module";
import { KontraktsmigreringComponent } from "./kontraktsmigrering.component";

@NgModule({
    imports: [
        RaskCommonModule,
        KontraktsmigreringComponent
    ],
    exports: [],
    providers: []
})
export class KontraktsmigreringModule { }
